var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"biz-chart-box"},[_c('div',{staticClass:"chart-title"},[_c('img',{staticClass:"charts-icon",attrs:{"src":require('@/assets/images/largescreen/charts-icon.png'),"alt":""}}),_c('dv-decoration-1'),_c('span',[_vm._v("分区域YTD装机家数及达标率")])],1),_c('div',{ref:"chart",staticClass:"biz-chart-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }